import { render, staticRenderFns } from "./systemParcelViewClientsPage.vue?vue&type=template&id=529d52c8&scoped=true&"
import script from "./systemParcelViewClientsPage.vue?vue&type=script&lang=js&"
export * from "./systemParcelViewClientsPage.vue?vue&type=script&lang=js&"
import style0 from "./systemParcelViewClientsPage.vue?vue&type=style&index=0&id=529d52c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529d52c8",
  null
  
)

export default component.exports